const PAGINATION_DEFAULT = {
  perPage: 10,
}

export {
  PAGINATION_DEFAULT
}
